import {
    CustomButton, WarningModal
} from "components/Common"
import React, { useEffect, useState } from "react"
import ReactExport from "react-export-excel"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const ButtonExport = ({
    data,
    rows,
    columns,
    t,
    itemActive,
}) => {
    const [dataSource, setDataSource] = useState([])
    const [warningModal, setWarningModal] = useState(false);

    useEffect(() => {
        if (data?.length > 0) {
            setDataSource(data)
        }
    }, [data])

    const filterColumns = data => {
        data.map(item => {
            item.selected = 1
        })
        return columns
    }

    const getFileName = () => {
        if (itemActive.Key == 2 && itemActive.parent?.ID_Group == "1") {
            return "Danh_sach_xet_nghiem_co_khoang_tham_chieu_theo_gioi_tinh_va_do_tuoi"
        } else if (itemActive.Key == 3 && itemActive.parent?.ID_Group == "1") {
            return `Danh_sach_xet_nghiem_co_khoang_tham_chieu_theo_may_xet_nghiem_${itemActive.Name}`
        } else if (itemActive.Key == 5 && itemActive.parent?.ID_Group == "1") {
            return "ResultTime"
        } else if (itemActive.Key == 4 && itemActive.parent?.ID_Group == "1") {
            return "Additional Info"
        } else if (itemActive.Key == 6 && itemActive.parent?.ID_Group == "1") {
            return "R104_TestConfig"
        }
        return "R101_TestConfig";
    }
    return (
        <React.Fragment>
            <ExcelFile
                filename={getFileName()}
                element={
                    <CustomButton color="primary" outline
                        onClick={(e) => {
                            if (rows.length == 0) {
                                setWarningModal(true)
                                e.preventDefault()
                                e.stopPropagation()
                            }
                        }}
                    >
                        {t("common:Download")}
                    </CustomButton>
                }
            >
                <ExcelSheet data={dataSource} name="Test">
                    {dataSource?.length > 0 &&
                        filterColumns(dataSource).map((col, _idx) => {
                            return (
                                <ExcelColumn key={_idx} label={col} value={col} />
                            )
                        })}
                </ExcelSheet>
            </ExcelFile>
            <WarningModal
                modal={warningModal}
                onToggle={() => setWarningModal(prev => !prev)}
                message={t("message:SelectRowWarning")}
            />
        </React.Fragment>
    )
}

const mapStateToProps = ({ }) => ({
})

const mapDispatchToProps = dispatch => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation(["message"])(ButtonExport)))